import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Modal,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import { useForm, Controller } from "react-hook-form";
import { AddIcCallOutlined, Edit, EditNotifications } from "@mui/icons-material";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%", // previously 35%
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  borderRadius: "8px",
};
const UpdateLeaveModal = ({
  leave,
  refresh,
  getLeave,
  singleLeaveType = null,
}) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  // Determine which fields to show based on singleLeaveType prop
  const isSingleMode = singleLeaveType !== null;

  const defaultValues = isSingleMode
    ? {
        developer_id: leave?.user_id,
        [singleLeaveType]: leave?.[singleLeaveType],
        [`total_${singleLeaveType}`]: leave?.[`total_${singleLeaveType}`],
      }
    : {
        developer_id: leave?.user_id,
        cl: leave?.cl,
        sl: leave?.sl,
        compensatory: leave?.compensatory,
        el: leave?.el,
        ml: leave?.ml,
        pl: leave?.pl,
        bl: leave?.bl,
        total_cl: leave?.total_cl,
        total_sl: leave?.total_sl,
        total_compensatory: leave?.total_compensatory,
        total_el: leave?.total_el,
        total_ml: leave?.total_ml,
        total_pl: leave?.total_pl,
        total_bl: leave?.total_bl,
      };

  const { control, handleSubmit, setValue, reset } = useForm({
    defaultValues,
  });

  const handleOpen = () => {
    reset(defaultValues);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    reset();
  };

  const onSubmit = (data) => {
    const payload = {
      user_id: leave?.user_id,
      ...Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          parseFloat(value) || 0,
        ])
      ),
    };

    postJsonData(
      ApiEndpoints.UPDATE_DEVELOPER_LEAVE,
      payload,
      setRequest,
      (res) => {
        okSuccessToast(res.data.message);
        handleClose();
        if (refresh) refresh();
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  return (
    <div>
      <IconButton
        onClick={handleOpen}
        sx={{ p: 0, color: "blue" }}
        size="small"
      >
        {isSingleMode ? <AddIcCallOutlined /> : <Edit />}
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxHeight: "90vh",
            overflowY: "auto",
            width: isSingleMode ? 400 : "auto",
          }}
        >
          <ModalHeader
            title={
              isSingleMode
                ? `Update ${getLeaveName(singleLeaveType)}`
                : "Update Developer Leave"
            }
            handleClose={handleClose}
          />

          {/* Conditionally render form fields */}
          {isSingleMode ? (
            // Single leave mode fields
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Controller
                  name={`total_${singleLeaveType}`}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label={`Total ${getLeaveName(singleLeaveType)}`}
                      type="number"
                      fullWidth
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name={singleLeaveType}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label={`Current ${getLeaveName(singleLeaveType)} Balance`}
                      type="number"
                      fullWidth
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Grid>
            </Grid>
          ) : (
            // Full leave mode fields (original)
            <Grid container spacing={2}>
              {/* ... original two-column layout */}
            </Grid>
          )}

          <ModalFooter
            btn={
              isSingleMode
                ? `Update ${getLeaveName(singleLeaveType)}`
                : "Update Leave"
            }
            onClick={handleSubmit(onSubmit)}
          />
        </Box>
      </Modal>
    </div>
  );
};
const getLeaveName = (leaveType) => {
  const leaveNames = {
    cl: "Casual Leave",
    sl: "Sick Leave",
    el: "Earn Leave",
    ml: "Maternity Leave",
    pl: "Paternity Leave",
    bl: "Bereavement Leave",
    compensatory: "Compensatory Leave",
  };
  return leaveNames[leaveType] || leaveType;
};
export default UpdateLeaveModal;
